module.exports = __webpack_public_path__ + "static/img/renliziyuan.7c86953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renliziyuan.jpg
// module id = fSgE
// module chunks = 1